import { Component, OnInit, ViewChild } from '@angular/core';
import {NavController, NavParams,ToastController } from 'ionic-angular';


import { ConectorProvider } from "../../providers/conector/conector";
import { GlobalProvider } from "../../providers/global/global";


import { CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';


import * as moment from 'moment';


@Component({
  selector: 'page-cuadrante-centro',
  templateUrl: 'cuadrante-centro.html',
})
export class CuadranteCentroPage implements OnInit {
  data:any={};

  turnos : any = [];
  licencias : any = [];

  verfecha = new Date()
  centros:any;
  centroSel:any;

  tiposlicencia:any = this.global.CONFIGURA["tipos_licencia"];

 

  ValPersCuadCentro :any = {
     "fechaCuadrante": moment(new Date()).format("DD-MM-YYYY") , 
     "centroCuadrante" :  20 // central 
    }

  calendarOptions: Options;
  @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;

  constructor(public navCtrl: NavController, public navParams: NavParams,public global: GlobalProvider, public conector:ConectorProvider,private toastCtrl: ToastController) {
           
    this.data = {
      "background"      : "assets/images/background/39.jpg", 
   };
   
    this.centros =  this.global.CONFIGURA["centros"]
    
    if(this.global.CONFIGURA["ValPersCuadCentro"]){
      this.ValPersCuadCentro = this.global.CONFIGURA["ValPersCuadCentro"]
      this.centroSel = this.ValPersCuadCentro.centroCuadrante;
      
      this.loadEvents(this.ValPersCuadCentro.fechaCuadrante,this.ValPersCuadCentro.centroCuadrante )    
      
    } else {
      this.global.CONFIGURA["ValPersCuadCentro"] = this.ValPersCuadCentro
    }

  }

  fechatoIso(f,h){
    let ef = f.split("-")   
    return (ef[2]+"-"+ef[1]+"-"+ef[0]+"T"+h)
  }


  ngOnInit() {

    this.calendarOptions = {
      editable: true,
      eventLimit: false,
      locale:'es',
      height:450,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay,listMonth',
        
      },
      buttonText: {
        today:    'hoy',
        month:    'mes',
        week:     'semana',
        day:      'dia',
        list:     'lista'
      },
      events:[]
    };
    

     
    this.loadEvents(this.ValPersCuadCentro.fechaCuadrante,this.ValPersCuadCentro.centroCuadrante )    

     
  
  }

  loadEvents(f,centro){
    this.conector.getcuadrantecentro(f,centro).subscribe(data => {
      // actualizamos eventos

      
      this.ucCalendar.fullCalendar('removeEvents');

      this.turnos = data["turnos"]
      this.licencias= data["licencias"]
     
      this.calendarOptions.events=[]

      let Leventos = []
     
      data["turnos"].forEach( (turno) => {
        //console.log("load turno",turno)
        let evento ={
          title: turno.empleado.usuario,				
          start: this.fechatoIso(turno.fecha,turno.horadesde),
          end: this.fechatoIso(turno.fecha,turno.horahasta),
          allDay: false,
          backgroundColor: turno.empleado.color,
          description: turno.horadesde +" a "+ turno.horahasta,
          icon: 'fa-clock-o',
          empleadoid:turno.empleado.id,
          nombrecompleto:turno.empleado.apellidos+", "+turno.empleado.nombre,
          turnoid: turno.id,
          centro: turno.centro.nombre
          
        }
        Leventos.push(evento);//push
      

      });
  
      
      
      this.licencias.forEach( (licencia) => {
        
        licencia.tiponombre = this.tiposlicencia[licencia.tipo]
        
        // fhasta es incluido en las vacaciones , calculamos el dia dia siguiente
        let diaSiguientefHasta =   moment(licencia.fhasta,"DD-MM-YYYY").add(1,"days").format("DD-MM-YYYY")
        
        let evento ={
          title: licencia.empleado.usuario,				
          start: this.fechatoIso(licencia.fdesde,"00:00:00"),
          end: this.fechatoIso(diaSiguientefHasta,"00:00:00"), 
          allDay: true,
          className:['claseLicencia_'+licencia.tipo],
          description: this.tiposlicencia[licencia.tipo],
          
          empleadoid:licencia.empleado.id,
          nombrecompleto:licencia.empleado.apellidos+", "+licencia.empleado.nombre,
          turnoid: null,
          centro: null
          
        }
        Leventos.push(evento);//push      

      });
      
      
      this.ucCalendar.fullCalendar('renderEvents',Leventos);
      this.ucCalendar.fullCalendar('gotoDate',this.fechatoIso(this.ValPersCuadCentro.fechaCuadrante,"00:00:00"));
    })//Conector
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CuadranteCentroPage');
  }

  ionViewWillEnter(){
  
  }
  eventClick(e){
    console.log("eventClick",e)
    let toast = this.toastCtrl.create({
      message: e.event.title +": " + e.event.description ,
      duration: 2000,
      position: 'middle'
    });

    toast.present();

  }

  clickButton(e){
     console.log("clickButton",e)

     if(e.buttonType=="prev" ||e.buttonType=="next"||e.buttonType=="today" ){

      this.ValPersCuadCentro.fechaCuadrante = e.data.format("DD-MM-YYYY")
      this.global.CONFIGURA["ValPersCuadCentro"] = this.ValPersCuadCentro
     this.loadEvents(this.ValPersCuadCentro.fechaCuadrante,this.ValPersCuadCentro.centroCuadrante )    
      

     }
  }
  updateEvent(){

  }
  siguiente(){

  }

  eligecentro(centroid){

    this.ValPersCuadCentro.centroCuadrante = centroid
    this.global.CONFIGURA["ValPersCuadCentro"] = this.ValPersCuadCentro
    this.loadEvents(this.ValPersCuadCentro.fechaCuadrante,this.ValPersCuadCentro.centroCuadrante )    


  }


}



// WEBPACK FOOTER //
// ./src/pages/cuadrante-centro/cuadrante-centro.ts